<template>
  <div
    class="icon"
    :class="{ small: small, tiny: tiny, large: large, medium: medium }"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    small: { type: Boolean, default: false },
    medium: { type: Boolean, default: false },
    tiny: { type: Boolean, default: false },
    large: { type: Boolean, default: false }
  }
};
</script>

<style lang="scss">
.icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  width: 24px;
  height: 24px;

  &.small {
    width: 16px;
    height: 16px;
  }

  &.medium {
    width: 20px;
    height: 20px;
  }

  &.large {
    width: 30px;
    height: 30px;
  }

  &.tiny {
    width: 10px;
    height: 10px;
  }

  img {
    display: block;
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
